<style>
.mobile-only {
  display: block;
}

@media (min-width: 992px) {
  .mobile-only {
    display: none;
  }
}

.desktop-only {
  display: block;
}

@media (max-width: 991px) {
  .desktop-only {
    display: none;
  }
}

/* Color background custom classes */
.radius_custom_blue {
  background-color: #007bff !important;
}
.radius_custom_green {
  background-color: #28a745 !important;
}
.radius_custom_warning {
  background-color: #ffc107 !important;
}
.radius_custom_red {
  background-color: #dc3545 !important;
}

/* Animaciones Pulse para Badges */
.pulse-blue { animation: pulse-badge-blue 1.5s infinite; }
@keyframes pulse-badge-blue {
  0% { box-shadow: 0 0 0 0 rgba(0, 123, 255, 0.8); }
  70% { box-shadow: 0 0 0 8px rgba(0, 123, 255, 0); }
  100% { box-shadow: 0 0 0 0 rgba(0, 123, 255, 0); }
}

.pulse-green { animation: pulse-badge-green 1.5s infinite; }
@keyframes pulse-badge-green {
  0% { box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.8); }
  70% { box-shadow: 0 0 0 8px rgba(40, 167, 69, 0); }
  100% { box-shadow: 0 0 0 0 rgba(40, 167, 69, 0); }
}

.pulse-warning { animation: pulse-badge-warning 1.5s infinite; }
@keyframes pulse-badge-warning {
  0% { box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.8); }
  70% { box-shadow: 0 0 0 8px rgba(255, 193, 7, 0); }
  100% { box-shadow: 0 0 0 0 rgba(255, 193, 7, 0); }
}

.pulse-red { animation: pulse-badge-red 1.5s infinite; }
@keyframes pulse-badge-red {
  0% { box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.8); }
  70% { box-shadow: 0 0 0 8px rgba(220, 53, 69, 0); }
  100% { box-shadow: 0 0 0 0 rgba(220, 53, 69, 0); }
} 

.hover-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08) !important;
  border-color: #28a745 !important;
}

.last-reviewed-card {
  background-color: #edf2f7 !important;
  border-color: #e9ecef !important;
}

.last-reviewed-card.hover-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(13, 110, 253, 0.2) !important;
  border-color: #007bff !important;
  background-color: #dfeafe !important;
}
</style>
<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box white_gradient_bg_light shadow_inset_lg">
        <h4 class="form-header">Activos Fijos</h4>
        <div class="controls-above-table">

        <div class="col-sm-12 col-md-11 col-lg-11 mx-auto">
            <div class="row mx-0 justify-content-center">
              <div class="col-sm-12 col-md-6 col-lg-4 my-2">
                <SelectProvider
                  class="w-100"
                  :placeholder="null"
                  v-model="filter.tienda"
                  :options="[{ codigo: '', nombre: 'Seleccione Tienda' }].concat(tiendas)"
                  optionValue="codigo"
                  :optionLabel="t => t.codigo ? t.codigo + ' - ' + t.nombre : t.nombre"
                  @change="filterData()"
                />
              </div>
              <div class="col-sm-12 col-md-6 col-lg-4 my-2">
                <SelectProvider
                  class="w-100"
                  :placeholder="null"
                  v-model="filter.centro_costo"
                  :options="[{ id: '', nombre: 'Seleccione Centro Costo' }].concat(centros_costo)"
                  optionValue="id"
                  :optionLabel="cc => cc.id ? cc.id + ' - ' + cc.nombre : cc.nombre"
                  @change="filterData()"
                />
              </div>
              <div class="col-sm-12 col-md-6 col-lg-4 my-2">
                <InputProvider
                  class="w-100"
                  placeholder="DPI Responsable"
                  v-model="dpi_responsable"
                  type="text"
                  @keyup.enter="filterData()"
                />
              </div>
              <div class="col-sm-12 col-md-6 col-lg-4 my-2">
                <SelectProvider
                  class="w-100"
                  :placeholder="null"
                  v-model="filterActivo"
                  :options="[
                    { value: null, label: 'Estado' },
                    { value: 'B', label: 'Buen Estado' },
                    { value: 'M', label: 'Mal Estado' },
                    { value: '9', label: 'De Baja' }
                  ]"
                  optionValue="value"
                  optionLabel="label"
                  @change="filterData()"
                />
              </div>
              <div class="col-sm-12 col-md-6 col-lg-4 my-2">
                <SelectProvider
                  class="w-100"
                  :placeholder="null"
                  v-model="filter.grupo"
                  :options="[{ id: null, nombre: 'Seleccione Categoría' }].concat(grupos)"
                  optionValue="id"
                  optionLabel="nombre"
                  @change="filterData()"
                />
              </div>
              <div class="col-sm-12 col-md-6 col-lg-4 my-2">
                <InputProvider
                  class="w-100"
                  placeholder="Identificador"
                  v-model="searchidentificador"
                  type="text"
                  @keyup.enter="filterData()"
                />
              </div>
              <div class="col-sm-12 col-md-6 col-lg-4 my-2">
                <InputProvider
                  class="w-100"
                  placeholder="Nombre de Activo"
                  v-model="searchtext"
                  type="text"
                  @keyup.enter="filterData()"
                />
              </div>
              <div class="col-sm-12 col-md-6 col-lg-4 my-2">
                <InputProvider
                  class="w-100"
                  placeholder="Barra GS1"
                  v-model="searchbarra"
                  type="text"
                  @keyup.enter="filterData()"
                />
              </div>
              <div class="col-sm-12 col-md-12 col-lg-4 my-2">
                <InputProvider
                  class="w-100"
                  placeholder="Código SAP"
                  v-model="searchcodigosap"
                  type="text"
                  @keyup.enter="filterData()"
                />
              </div>
              <div class="col-12 d-flex justify-content-center mt-3">
                <div class="input-group-append">
                  <button class="btn btn-outline-success btn-md px-3" style="border-radius: 60px" @click="filterData()">
                    <i class="fa fa-search"></i>
                  </button>
                  <button class="btn btn-outline-success btn-md px-3" style="border-radius: 60px" v-on:click="clearFilterData()">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="col-sm-12 col-md-11 col-lg-11 mx-auto">
            <div class="row justify-content-center">
              <div style="text-align: right">
                <router-link v-if="puedeCrearOModificar" class="btn btn-success px-5 py-3 my-2" 
                  style="border-radius: 20px; font-size: 8pt; font-weight: bold; cursor: pointer;" :to="{ name: 'af-activos-nuevo' }">
                  <i class="fa fa-plus"></i>
                  Agregar Nuevo
                </router-link>
              </div>
            </div>
          </div>
        </div>


        <!-- VFOR para las cards de los Activos -->
        <div class="row mx-0">
          <div 
            v-for="det in data.results" 
            :key="det.id" 
            class="col-12 col-lg-6 mb-3 px-2"
          >
            <div 
              class="p-3 shadow_inset_sm border_custom d-flex flex-column h-100 hover-card" 
              :class="det.id === ultimoActivoRevisadoId ? 'last-reviewed-card' : 'bg-white'"
              style="border-radius: 15px; border: 1px solid #e9ecef; transition: all 0.2s ease-in-out;" 
            >
              <div class="d-flex justify-content-between align-items-start mb-2">
                <div class="text-truncate mr-2" style="max-width: calc(100% - 85px);">
                  <div class="d-flex align-items-center">
                    <small class="font-weight-bold text-success d-block" style="font-size: 8pt; font-family: monospace;">
                      {{ det.identificador }}
                    </small>
                    <span v-if="det.id === ultimoActivoRevisadoId" class="badge badge-primary ml-2 px-2 py-1" style="font-size: 7pt; border-radius: 10px;">
                      <i class="fas fa-eye mr-1"></i>Último visto
                    </span>
                  </div>
                  <h6 class="font-weight-bold text-dark mb-0 mt-1 text-truncate" :title="det.nombre" style="font-size: 10pt;">
                    {{ det.nombre }}
                  </h6>
                </div>
                <div class="badge d-flex align-items-center justify-content-center text-white flex-shrink-0" style="border-radius: 25px; font-size: 8pt; padding: 4px 10px; height: 22px;" :class="{
                  'pulse-blue radius_custom_blue': det.estado == 'E',
                  'pulse-green radius_custom_green': det.estado == 'B',
                  'pulse-warning radius_custom_warning': det.estado == 'M',
                  'pulse-red radius_custom_red': det.estado == '9',
                }">
                  <span v-if="det.estado == 'E'">Excelente</span>
                  <span v-if="det.estado == 'B'">Buen Estado</span>
                  <span v-if="det.estado == 'M'">Mal Estado</span>
                  <span v-if="det.estado == '9'">De Baja</span>
                </div>
              </div>
              
              <hr class="my-2" style="border-top: 1px dashed #dee2e6;" />
              
              <div class="row mx-0 mb-2 flex-grow-1">
                <div class="col-6 px-0 pr-1 text-truncate">
                  <small class="text-secondary d-block" style="font-size: 8pt; letter-spacing: 0.5px;">CENTRO COSTO</small>
                  <span class="font-weight-bold text-dark text-truncate d-block" style="font-size: 8pt;" :title="getLocationName(det)">
                    <span v-if="det.tienda_obj">{{ det.tienda_obj.codigo }} - {{ det.tienda_obj.nombre }}</span>
                    <span v-else-if="det.centro_costo_obj">{{ det.centro_costo_obj.id }} - {{ det.centro_costo_obj.nombre }}</span>
                    <span v-else>-</span>
                  </span>
                </div>
                <div class="col-6 px-0 pl-1 text-right text-truncate">
                  <small class="text-secondary d-block" style="font-size: 8pt; letter-spacing: 0.5px;">CATEGORÍA</small>
                  <span class="font-weight-bold text-dark text-truncate d-block" style="font-size: 8pt;" :title="det.grupo_obj ? det.grupo_obj.nombre : '-'">
                    {{ det.grupo_obj ? det.grupo_obj.nombre : '-' }}
                  </span>
                </div>
              </div>

              <!-- Extra row for GS1 and SAP code if applicable -->
              <div class="row mx-0 mb-1" style="font-size: 8pt;">
                <div :class="det.codigo_sap && det.codigo_sap !== 'null' && det.codigo_sap !== 'None' && det.codigo_sap !== '' ? 'col-6 px-0 text-truncate' : 'col-12 px-0 text-truncate'" 
                     v-if="det.barra_gs1 && det.barra_gs1 !== 'null' && det.barra_gs1 !== 'None' && det.barra_gs1 !== ''">
                  <i class="fas fa-barcode text-success mr-1"></i>
                  <span class="text-secondary" style="font-family: monospace;">{{ det.barra_gs1 }}</span>
                </div>
                <div :class="det.barra_gs1 && det.barra_gs1 !== 'null' && det.barra_gs1 !== 'None' && det.barra_gs1 !== '' ? 'col-6 px-0 text-right text-truncate' : 'col-12 px-0 text-truncate'" 
                     v-if="det.codigo_sap && det.codigo_sap !== 'null' && det.codigo_sap !== 'None' && det.codigo_sap !== ''">
                  <i class="fas fa-network-wired text-info mr-1"></i>
                  <span class="text-secondary" style="font-family: monospace;">{{ det.codigo_sap }}</span>
                </div>
                <div class="col-12 px-0 text-truncate mt-1" v-if="det.estado == '9'">
                  <span class="badge badge-outline-danger text-truncate" style="border: 1px solid #dc3545; color: #dc3545; border-radius: 4px; padding: 2px 4px; font-size: 8pt; max-width: 100%; display: inline-block;">
                    Baja: {{ det.motivo_baja_obj || 'Desconocido' }}
                  </span>
                </div>
              </div>
              
              <div class="mt-auto pt-2 border-top-0">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <small class="text-muted" style="font-size: 8pt;">
                    {{ det.fecha_creacion | moment("DD/MM/YYYY hh:mm a") }}
                  </small>
                </div>
                <br/>
                <button 
                  class="btn btn-outline-success btn-sm w-100 d-flex justify-content-between align-items-center px-3 py-3" 
                  style="border-radius: 20px; font-size: 8pt; font-weight: bold; cursor: pointer;" 
                  @click="rowClick(det)"
                >
                  <span>Inspeccionar</span>
                  <i class="fa fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>



        <div class="row mx-0">
          <div class="col-12 d-flex justify-content-center mt-5">
            <PaginationComponent :currentPage="currentPage" :data="data" @pagechanged="onPageChange" />
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";
import InputProvider from "@/components/atomic/atoms/inputs/InputProvider.vue";
import SelectProvider from "@/components/atomic/atoms/inputs/SelectProvider.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    PaginationComponent,
    InputProvider,
    SelectProvider,
  },
  data() {
    return {
      current: {},
      mostrarRefresh: false,
      filter: { tienda: "", centro_costo: "", grupo: null },
      currentPage: 1,
      searchidentificador: "",
      searchtext: "",
      searchbarra: "",
      searchcodigosap: "",
      filterActivo: null,
      dpi_responsable: "",
      ultimoActivoRevisadoId: null,
      centros_costo: [],
      grupos: [],
      data: [],
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
    puedeCrearOModificar() {
      try {
        const grupos = JSON.parse(localStorage.getItem("grupos") || "[]");
        return grupos.some(g => g.nombre === 'AdminProteccionActivos' || g.nombre === 'Admin');
      } catch (e) {
        return false;
      }
    },
  },
  mounted() {
    this.$store.dispatch("catalogos/llenar_tiendas", { activa: true, quitar_paginacion: true });
    this.refreshGrupos();
    this.refreshCentroCosto();

    const savedState = this.loadStateFromSession();
    if (savedState) {
      this.currentPage = savedState.page || 1;
      this.filter.tienda = savedState.tienda || "";
      this.filter.centro_costo = savedState.centro_costo || "";
      this.filter.grupo = savedState.grupo !== undefined ? savedState.grupo : null;
      this.searchidentificador = savedState.identificador || "";
      this.searchtext = savedState.searchtext || "";
      this.searchbarra = savedState.barra_gs1 || "";
      this.dpi_responsable = savedState.dpi_responsable || "";
      this.searchcodigosap = savedState.codigo_sap || "";
      this.filterActivo = savedState.estado !== undefined ? savedState.estado : null;
      this.ultimoActivoRevisadoId = savedState.ultimoActivoId || null;

      this.refreshData({
        page: this.currentPage,
        tienda: this.filter.tienda,
        centro_costo: this.filter.centro_costo,
        grupo: this.filter.grupo,
        identificador: this.searchidentificador,
        "filter[search]": this.searchtext,
        barra_gs1: this.searchbarra,
        dpi_responsable: this.dpi_responsable,
        codigo_sap: this.searchcodigosap,
        estado: this.filterActivo,
      });
    } else {
      this.refreshData();
    }
  },
  watch: {
    searchbarra(newVal) {
      if (newVal.length > 17) {
        // Eliminar "01" si está al inicio
        if (newVal.startsWith("01")) {
          newVal = newVal.substring(2);
        }
        // Eliminar el último carácter
        newVal = newVal.slice(0, -1);
        // Asignar el nuevo valor a searchbarra
        this.searchbarra = newVal;
      }
      this.searchbarra = newVal;
    },
  },
  methods: {
    saveStateToSession() {
      const state = {
        page: this.currentPage,
        tienda: this.filter.tienda,
        centro_costo: this.filter.centro_costo,
        grupo: this.filter.grupo,
        identificador: this.searchidentificador,
        searchtext: this.searchtext,
        barra_gs1: this.searchbarra,
        dpi_responsable: this.dpi_responsable,
        codigo_sap: this.searchcodigosap,
        estado: this.filterActivo,
        ultimoActivoId: this.ultimoActivoRevisadoId,
      };
      sessionStorage.setItem("af_activos_state", JSON.stringify(state));
    },
    loadStateFromSession() {
      const saved = sessionStorage.getItem("af_activos_state");
      if (!saved) return null;
      try {
        return JSON.parse(saved);
      } catch (e) {
        return null;
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.saveStateToSession();
      this.refreshData({
        page: this.currentPage,
        tienda: this.filter.tienda,
        centro_costo: this.filter.centro_costo,
        grupo: this.filter.grupo,
        identificador: this.searchidentificador,
        "filter[search]": this.searchtext,
        barra_gs1: this.searchbarra,
        dpi_responsable: this.dpi_responsable,
        codigo_sap: this.searchcodigosap,
        estado: this.filterActivo,
      });
    },
    filterData() {
      this.currentPage = 1;
      this.saveStateToSession();
      this.refreshData({
        page: 1,
        grupo: this.filter.grupo,
        tienda: this.filter.tienda,
        centro_costo: this.filter.centro_costo,
        identificador: this.searchidentificador,
        "filter[search]": this.searchtext,
        barra_gs1: this.searchbarra,
        dpi_responsable: this.dpi_responsable,
        codigo_sap: this.searchcodigosap,
        estado: this.filterActivo,
      });
    },
    clearFilterData() {
      this.currentPage = 1;
      this.searchidentificador = "";
      this.searchtext = "";
      this.searchbarra = "";
      this.dpi_responsable = "",
      this.searchcodigosap = "";
      this.filterActivo = null;
      this.filter.tienda = "";
      this.filter.centro_costo = "";
      this.filter.grupo = null;
      this.ultimoActivoRevisadoId = null;
      sessionStorage.removeItem("af_activos_state");
      this.refreshData({
        page: 1,
      });
    },
    refreshCentroCosto() {
      let self = this;
      DynamicService.fetch("cat", "centro-costo", {
        quitar_paginacion: true,
        activa: true,
      }).then((res) => {
        self.centros_costo = res.data;
      });
    },
    refreshGrupos() {
      let self = this;
      DynamicService.fetch("af", "grupo", {
        quitar_paginacion: true,
      }).then((res) => {
        self.grupos = res.data;
      });
    },
    onRefreshData() { },



    refreshData(params) {
      let self = this;
      DynamicService.fetch("af", "activo", params).then((res) => {
        self.data = res.data;
        console.log("data on Refresh AF: ") // TD0130000315
        console.log(self.data.results)
      });
    },



    rowClick(current) {
      let self = this;
      self.ultimoActivoRevisadoId = current.id;
      self.saveStateToSession();
      self.$router.push({
        name: "af-activos-editar",
        params: { id: current.id },
      });
    },

    getLocationName(det) {
      if (det.tienda_obj) {
        return `${det.tienda_obj.codigo} - ${det.tienda_obj.nombre}`;
      } else if (det.centro_costo_obj) {
        return `${det.centro_costo_obj.id} - ${det.centro_costo_obj.nombre}`;
      }
      return '-';
    },

  },
};
</script>
